import Vue from 'vue';
import { isMcp } from './Auth';

Vue.prototype.$isMcp = isMcp;